import { gql, useMutation, useQuery } from "@apollo/client";
import {
  Add,
  ArrowDropDown,
  ArrowDropUp,
  ContentCopy,
  Delete,
  Edit,
  Settings,
  Star,
} from "@mui/icons-material";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Checkbox,
  ClickAwayListener,
  Divider,
  IconButton,
  MenuItem,
  Modal,
  OutlinedInput,
  Paper,
  Popper,
  Select,
  Skeleton,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  addDays,
  addHours,
  differenceInMinutes,
  format,
  getHours,
  isAfter,
  isBefore,
  isEqual,
  isSameDay,
  isValid,
  parse,
  setDate,
  setHours,
  setMinutes,
  setSeconds,
} from "date-fns";
import "../../assets/css/Availability.css";
import React, { useCallback, useEffect, useRef, useState } from "react";
import AvailabilityCalendar from "./AvailabilityCalendar";
import MultiSelector from "./MultiSelector";
import HourFormat from "../../util/hourFormat";
import EventTypesPopper from "./EventTypesPopper";
import Error from "../Error";
import {
  ADD_COMPANY_HOUR,
  ADD_COMPANY_HOUR_GROUP,
  ADD_OVERRIDE,
  ADD_OVERRIDE_GROUP,
  DELETE_COMPANY_HOUR,
  DELETE_COMPANY_HOUR_GROUP,
  DELETE_OVERRIDE_GROUP,
  UPDATE_COMPANY_HOUR,
  UPDATE_COMPANY_HOUR_GROUP,
  UPDATE_OVERRIDE,
} from "../../graphql/mutations";
import {
  getCompanyGroupsHours,
  getCompanyHours,
  getOverrideGroups,
  getOverrides,
} from "../../graphql/querys";
const CancelModal = (props) => {
  // State variables
  const [selects, setSelects] = useState(
    props.showCancelModal3
      ? props.groupData?.getCompanyGroupsHours.find(
          (obj) =>
            obj.id !==
            props.groupData?.getCompanyGroupsHours[props.selectedTab].id
        ).id
      : ""
  );
  const [names, setNames] = useState(
    props.showCancelModal2
      ? props.groupData?.getCompanyGroupsHours[props.selectedTab].title
      : ""
  );

  // Function for handling input change in a job
  const handleInputChange = (index, key, value) => {
    props.setJobs((prevJobs) => {
      const updatedJobs = [...prevJobs];
      updatedJobs[index][key] = value;
      return updatedJobs;
    });
  };

  // Function for deleting a job
  const handleDeleteJob = (index) => {
    props.setJobs((prevJobs) => {
      const updatedJobs = [...prevJobs];
      updatedJobs.splice(index, 1);
      return updatedJobs;
    });
  };

  // Function for adding a job
  const handleAddJob = useCallback(() => {
    props.setJobs([
      ...props.jobs,
      {
        startTime: format(
          new Date(
            addHours(
              parse(
                props.jobs[props.jobs.length - 1]?.endTime
                  ? props.jobs[props.jobs.length - 1]?.endTime
                  : "8:00am",
                props.jobs[props.jobs.length - 1]?.endTime
                  ? HourFormat()
                  : "h:mmaa",
                new Date()
              ),
              1
            )
          ),
          HourFormat()
        ).toLowerCase(),
        endTime: format(
          new Date(
            addHours(
              parse(
                props.jobs[props.jobs.length - 1]?.endTime
                  ? props.jobs[props.jobs.length - 1]?.endTime
                  : "3:00pm",
                props.jobs[props.jobs.length - 1]?.endTime
                  ? HourFormat()
                  : "h:mmaa",
                new Date()
              ),
              2
            )
          ),
          HourFormat()
        ).toLowerCase(),
      },
    ]);
  }, [props.jobs]);
  // Function for handling overrides
  const handleOverride = async (e) => {
    var temp = props.showCancelModal5;
    e ? props.setShowCancelModal5(false) : props.setShowCancelModal4(false);
    var yes = false;
    if (e) {
      const promises = props.data?.getCompanyHours
        .filter(
          (obj) =>
            obj.day == format(temp, "EEEE") &&
            parseInt(
              props.groupData?.getCompanyGroupsHours[props.selectedTab].id
            ) == parseInt(obj.groupId)
        )
        .map((id) => {
          return props
            .deleteCompanyHour({
              variables: {
                id: parseInt(id.id),
              },
            })
            .then((res) => {
              props.refetch({
                userId: props.currentUser.userId,
                hours24: HourFormat(),
              });
              props.groupRefetch();
              props.setUpdating(true);
            })
            .catch((err) => {
              props.refetch({
                userId: props.currentUser.userId,
                hours24: HourFormat(),
              });
              props.groupRefetch();
              console.error(err);
            });
        });

      await Promise.all(promises).then(() => {
        props.jobs.map((val) =>
          props
            .addCompanyHour({
              variables: {
                userId: props.currentUser.userId,
                onJob: true,
                day: format(temp, "EEEE"),
                startTime: props.translateFormat(
                  val.startTime,
                  "h:mmaa",
                  HourFormat()
                ),
                endTime: props.translateFormat(
                  val.endTime,
                  "h:mmaa",
                  HourFormat()
                ),
                groupId: parseInt(
                  props.groupData?.getCompanyGroupsHours[props.selectedTab]?.id
                ),
              },
            })
            .then((res) => {
              props.refetch({
                userId: props.currentUser.userId,
                hours24: HourFormat(),
              });
              props.groupRefetch();
              props.setUpdating(true);
            })
            .catch((err) => {
              props.refetch({
                userId: props.currentUser.userId,
                hours24: HourFormat(),
              });
              props.groupRefetch();
              console.error(err);
            })
        );
      });
    } else {
      Array.isArray(props.groupId)
        ? props.groupId
            .map((val) => {
              return (
                props.overrideGroupData?.getOverrideGroups.find(
                  (vall) => vall.id == val
                )?.date || ""
              );
            })
            .map((val, ind) => {
              yes = props.selectedDates.find((vall) =>
                isSameDay(new Date(val), new Date(vall))
              )
                ? yes
                : true;
            })
        : (yes = props.selectedDates.find((vall) =>
            isSameDay(
              new Date(
                props.overrideGroupData?.getOverrideGroups.find(
                  (vall) => vall.id == props.groupId
                )?.date
              ),
              new Date(vall)
            )
          )
            ? yes
            : true);

      if (yes) {
        if (Array.isArray(props.groupId)) {
          const promises = props.groupId.map((id) => {
            return props
              .deleteOverrideGroup({
                variables: {
                  id: parseInt(id),
                },
              })
              .then((res) => {
                props.overrideGroupRefetch();
                props.overrideRefetch();
                props.setUpdating(true);
              })
              .catch((err) => {
                props.overrideRefetch();
                console.error(err);
              });
          });

          await Promise.all(promises);
        } else {
          await props
            .deleteOverrideGroup({
              variables: {
                id: parseInt(props.groupId),
              },
            })
            .then((res) => {
              props.overrideGroupRefetch();
              props.overrideRefetch();
              props.setUpdating(true);
            })
            .catch((err) => {
              props.overrideRefetch();
              console.error(err);
            });
        }

        props.setUse([]);
      }
      props.setUse([]);
      const overrideGroupPromises = props.selectedDates.map((date) => {
        return props.addOverrideGroup({
          variables: {
            input: {
              userId: props.currentUser.userId,
              groupId: parseInt(
                props.groupData?.getCompanyGroupsHours[props.selectedTab].id
              ),
              date: new Date(setHours(new Date(date), 17))
                .toISOString()
                .slice(0, 10),
              normalOverrides: props.jobs.map((date, ind) => ({
                userId: props.currentUser.userId,
                startTime: props.translateFormat(
                  date.startTime,
                  "hh:mmaa",
                  HourFormat()
                ),
                endTime: props.translateFormat(
                  date.endTime,
                  "hh:mmaa",
                  HourFormat()
                ),
              })),
            },
          },
        });
      });

      await Promise.all(overrideGroupPromises)
        .then(() => {
          props.setUpdating(true);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          props.overrideRefetch();
          props.overrideGroupRefetch();
        });
    }
    props
      .refetch({
        userId: props.currentUser.userId,
        hours24: HourFormat(),
      })
      .then((res) => {
        props.refetch({
          userId: props.currentUser.userId,
          hours24: HourFormat(),
        });
      });
    props.groupRefetch();
  };

  // Function for handling cancel actions
  const handleCancel = (val) => {
    props.showCancelModal3
      ? props.setShowCancelModal3(false)
      : props.showCancelModal
      ? props.setShowCancelModal(false)
      : props.setShowCancelModal2(false);
    props.showCancelModal3
      ? props
          .deleteCompanyHourGroup({
            variables: {
              groupId: parseInt(
                props.groupData?.getCompanyGroupsHours[props.selectedTab].id
              ),
              newDefault: parseInt(selects),
            },
          })
          .then((res) => {
            props.setSelectedTab(
              props.selectedTab - 1 >= 0 ? props.selectedTab - 1 : 0
            );
            props.setUpdating(true);
            setTimeout(() => {
              props.refetch({
                userId: props.currentUser.userId,
                hours24: HourFormat(),
              });
              props.groupRefetch();
            }, 5);
          })
          .catch((err) => {
            props.setSelectedTab(
              props.selectedTab - 1 >= 0 ? props.selectedTab - 1 : 0
            );
            console.log(err);
            setTimeout(() => {
              props.refetch({
                userId: props.currentUser.userId,
                hours24: HourFormat(),
              });
              props.groupRefetch();
            }, 5);
          })
      : props.showCancelModal2
      ? props
          .updateCompanyHourGroup({
            variables: {
              input: {
                title: names,
                def: props.groupData?.getCompanyGroupsHours[props.selectedTab]
                  .def,
              },
              groupId: parseInt(
                props.groupData?.getCompanyGroupsHours[props.selectedTab].id
              ),
            },
          })
          .then((res) =>
            setTimeout(
              () =>
                props.groupRefetch().then((res) => {
                  props.setUpdating(true);
                }),
              5
            )
          )
      : props.showCancelModal4
      ? handleOverride()
      : props.showCancelModal5
      ? handleOverride("e")
      : props
          .addCompanyHourGroup({
            variables: {
              input: {
                userId: props.currentUser.userId,
                def: false,
                title: names,
              },
            },
          })
          .then((res) => {
            setTimeout(() => {
              Promise.all([
                props.groupRefetch(),
                props.refetch({
                  userId: props.currentUser.userId,
                  hours24: HourFormat(),
                }),
              ]).then((results) => {
                props.setUpdating(true);
              });
            }, 5);
          })
          .catch((err) => {
            setTimeout(() => {
              Promise.all([props.groupRefetch(), props.refetch()]).then(
                (results) => {
                  // console.log(results);
                }
              );
            }, 5);
          });
    props.refetch({
      userId: props.currentUser.userId,
      hours24: HourFormat(),
    });
    props.groupRefetch();
  };

  // State variable for error handling
  const [error, setError] = useState(false);

  // Function for validating the time ranges of props.jobs
  function validate() {
    return new Promise((resolve, reject) => {
      try {
        for (let i = 0; i < props.jobs.length; i++) {
          if (
            isValid(parse(props.jobs[i].startTime, HourFormat(), new Date())) &&
            isValid(parse(props.jobs[i].endTime, HourFormat(), new Date())) &&
            differenceInMinutes(
              parse(props.jobs[i].startTime, HourFormat(), new Date()),
              parse(props.jobs[i].endTime, HourFormat(), new Date())
            ) < 0
          ) {
          } else {
            setError(true);
            reject(`Invalid time range for job ${i + 1}`);
            return;
          }
        }
        resolve("All jobs have valid time ranges");
      } catch (err) {
        setError(true);
        reject(err);
      }
    });
  }
  const handleDateChange = (dates) => {
    props.setSelectedDates(dates);
  };
  return (
    <Modal
      className="modal"
      open={
        props.showCancelModal ||
        props.showCancelModal2 ||
        props.showCancelModal3 ||
        props.showCancelModal4 ||
        props.showCancelModal5
      }
      onClose={
        props.showCancelModal3
          ? () => props.setShowCancelModal3(false)
          : props.showCancelModal
          ? () => props.setShowCancelModal(false)
          : props.showCancelModal4
          ? () => {
              props.setSelectedDates([]);
              props.setUse([]);
              props.setShowCancelModal4(false);
            }
          : props.showCancelModal5
          ? () => props.setShowCancelModal5(false)
          : () => props.setShowCancelModal2(false)
      }
    >
      <Box
        sx={{
          position: "absolute",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: "10px",
          outline: "none",
          maxWidth: "400px",
          display: "flex",
          gap: "14px",
          maxHeight: "800px",
          overflow: "auto",
          flexDirection: "column",
        }}
      >
        <h1>
          {/* Determine the title of the modal based on the current state */}
          {props.showCancelModal3
            ? `Delete ${
                props.groupData?.getCompanyGroupsHours[props.selectedTab].title
              }?`
            : props.showCancelModal2
            ? "Update Schedule Name"
            : props.showCancelModal4
            ? "Select the date(s) you want to assign specific hours"
            : props.showCancelModal5
            ? format(props.showCancelModal5, "EEEE") + " Availability"
            : "New Schedule"}
        </h1>
        {!props.showCancelModal3 &&
          !props.showCancelModal4 &&
          !props.showCancelModal5 &&
          "Schedule Name"}
        {props.showCancelModal5 ? (
          <div className="time">
            <b>What hours are you available?</b>
            <div className="displayFlex">
              <div className="timebox" style={{ justifyContent: "center" }}>
                {props.jobs.length === 0 ? (
                  <Typography className="unavailable">Unavailable</Typography>
                ) : (
                  props.jobs.map((job, index) => (
                    <props.Job
                      key={index}
                      job={job}
                      index={index}
                      handleInputChange={handleInputChange}
                      handleDeleteJob={handleDeleteJob}
                    />
                  ))
                )}
              </div>

              <div
                className="flex justify align"
                style={{
                  minHeight: "60px",
                }}
              >
                <IconButton
                  onClick={() => {
                    handleAddJob();
                  }}
                >
                  <Add />
                </IconButton>
              </div>
            </div>
          </div>
        ) : props.showCancelModal4 ? (
          <div className="displayFlex column">
            <MultiSelector
              selectedDates={props.selectedDates}
              setSelectedDates={props.setSelectedDates}
              use={props.use}
              handleDateChange={handleDateChange}
            />
            {props.selectedDates.length !== 0 && (
              <div className="time">
                <b>What hours are you available?</b>
                <div className="displayFlex">
                  <div className="timebox">
                    {props.jobs.length === 0 ? (
                      <Typography className="unavailable">
                        Unavailable
                      </Typography>
                    ) : (
                      props.jobs.map((job, index) => (
                        <props.Job
                          key={index}
                          job={job}
                          index={index}
                          handleInputChange={handleInputChange}
                          handleDeleteJob={handleDeleteJob}
                        />
                      ))
                    )}
                  </div>

                  <div
                    className="flex justify align"
                    style={{
                      minHeight: "60px",
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        handleAddJob();
                      }}
                    >
                      <Add />
                    </IconButton>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : props.showCancelModal3 ? (
          <>
            <Typography>
              This action cannot be undone. Any event types associated with this
              schedule will be set to custom availability with these hours.
            </Typography>
            <br />
            {props.groupData?.getCompanyGroupsHours[props.selectedTab].def && (
              <>
                New Default:
                <Select
                  value={selects}
                  onChange={(e) => {
                    setSelects(e.target.value);
                  }}
                >
                  {props.groupData?.getCompanyGroupsHours
                    .filter(
                      (obj) =>
                        obj.id !==
                        props.groupData?.getCompanyGroupsHours[
                          props.selectedTab
                        ].id
                    )
                    .map((val, ind) => (
                      <MenuItem key={ind} value={val.id}>
                        {val.title}
                      </MenuItem>
                    ))}
                </Select>
              </>
            )}
          </>
        ) : (
          <OutlinedInput
            value={names}
            onChange={(e) => setNames(e.target.value)}
            placeholder="Schedule Name..."
          />
        )}
        <Typography color="error" style={{ display: !error ? "none" : "flex" }}>
          Provide a valid time
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            onClick={
              props.showCancelModal3
                ? () => props.setShowCancelModal3(false)
                : props.showCancelModal
                ? () => props.setShowCancelModal(false)
                : props.showCancelModal4
                ? () => props.setShowCancelModal4(false)
                : props.showCancelModal5
                ? () => props.setShowCancelModal5(false)
                : () => props.setShowCancelModal2(false)
            }
            sx={{ mr: 2 }}
          >
            Nevermind
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              props.showCancelModal4 || props.showCancelModal5
                ? validate().then((res) => handleCancel())
                : handleCancel();
            }}
            style={{ background: "#d9bca9" }}
          >
            {props.showCancelModal3
              ? "Delete"
              : props.showCancelModal2
              ? "Update"
              : "Create"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
function AvailabilityPage(props) {
  const handleTabChange = (event, newValue) => {
    event ? setSelectedTab(event.target.value) : setSelectedTab(newValue);
  };

  const Hover = (props) => {
    return (
      <div
        className="hovered"
        onClick={() => {
          props.onClick();
          setOpen(false);
        }}
      >
        {props.children}
      </div>
    );
  };
  const isSmallScreen = useMediaQuery("(max-width:1000px)");
  const [updateCompanyHour] = useMutation(UPDATE_COMPANY_HOUR);
  const [updateCompanyHourGroup] = useMutation(UPDATE_COMPANY_HOUR_GROUP);
  const [addCompanyHour] = useMutation(ADD_COMPANY_HOUR);
  const [addOverride] = useMutation(ADD_OVERRIDE);
  const [addOverrideGroup] = useMutation(ADD_OVERRIDE_GROUP);
  const [deleteCompanyHour] = useMutation(DELETE_COMPANY_HOUR);
  const [deleteOverrideGroup] = useMutation(DELETE_OVERRIDE_GROUP);
  const [deleteCompanyHourGroup] = useMutation(DELETE_COMPANY_HOUR_GROUP);
  const [updateOverride] = useMutation(UPDATE_OVERRIDE);
  const [addCompanyHourGroup] = useMutation(ADD_COMPANY_HOUR_GROUP);
  const [updating, setUpdating] = useState(false);
  const timeoutRef = useRef(null);
  const timeoutActiveRef = useRef(false);
  const notificationRef = useRef(null);
  const errorTimeoutRef = useRef(null);
  const errorTimeoutActiveRef = useRef(false);
  const errorRef = useRef(null);
  const {
    loading: overrideGroupLoading,
    error: overrideGroupError,
    data: overrideGroupData,
    refetch: overrideGroupRefetch,
  } = useQuery(getOverrideGroups, {
    variables: {
      userId: props.currentUser.userId,
    },
  });
  const { loading, error, data, refetch } = useQuery(getCompanyHours, {
    variables: {
      userId: props.currentUser.userId,
      hours24: HourFormat(),
      sorted: true,
    },
  });
  const {
    loading: customLoading,
    error: customError,
    data: customData,
    refetch: customRefetch,
  } = useQuery(getCompanyGroupsHours, {
    variables: {
      userId: props.currentUser.userId,
    },
  });
  const {
    loading: groupLoading,
    error: groupError,
    data: groupData,
    refetch: groupRefetch,
  } = useQuery(getCompanyGroupsHours, {
    variables: {
      userId: props.currentUser.userId,
      custom: false,
    },
  });
  const {
    loading: overrideLoading,
    error: overrideError,
    data: overrideData,
    refetch: overrideRefetch,
  } = useQuery(getOverrides, {
    variables: {
      userId: props.currentUser.userId,
      hours24: HourFormat(),
    },
  });
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedOverrides, setSelectedOverrides] = useState(0);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showCancelModal2, setShowCancelModal2] = useState(false);
  const [showCancelModal3, setShowCancelModal3] = useState(false);
  const [showCancelModal4, setShowCancelModal4] = useState(false);
  const [showCancelModal5, setShowCancelModal5] = useState(false);
  const [temp, setTemp] = useState([]);
  const [open, setOpen] = useState(false);
  const anchorRef = React.useRef(null);
  useEffect(() => {
    if (showCancelModal4 || showCancelModal5) {
      setSelectedDates(use.length ? use.map((val) => new Date(val)) : []);
    }
  }, [showCancelModal4, showCancelModal5]);
  // This function translates a given time format to another format based on the provided time and formats.
  // If a second parameter is provided, it will be used as the default format.
  // It uses the `parse` function to parse the time string into a Date object, and then formats it using the `format` function.
  function translateFormat(time, formats, second) {
    return format(parse(time, second || "hh:mmaa", new Date()), formats);
  }

  // This function is triggered when a click event occurs.
  // It toggles the state of the "open" variable by negating its previous value.
  const handleClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  // This function is triggered when the user closes a component.
  // It checks if the click event target is inside a specified anchor reference,
  // and if not, it sets the "open" variable to false.
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  // State variables
  const [jobs, setJobs] = useState([
    {
      startTime: translateFormat("9:00am", HourFormat()),
      endTime: translateFormat("5:00pm", HourFormat()),
    },
  ]);
  const [use, setUse] = useState([]);
  const [groupId, setGroupId] = useState([]);

  // React memoized component for rendering a job
  const Job = React.memo(
    ({ handleDeleteJob, handleInputChange, index, job }) => {
      return (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "space-between",
            minWidth: "270px",
          }}
        >
          <div>
            <OutlinedInput
              className="input"
              type="text"
              value={job.startTime.toLowerCase()}
              onChange={(e) =>
                handleInputChange(index, "startTime", e.target.value)
              }
            />{" "}
            -{" "}
            <OutlinedInput
              className="input"
              type="text"
              value={job.endTime.toLowerCase()}
              onChange={(e) =>
                handleInputChange(index, "endTime", e.target.value)
              }
            />
            <IconButton onClick={() => handleDeleteJob(index)}>
              <Delete />
            </IconButton>
          </div>
        </div>
      );
    }
  );

  // useEffect hook that runs when the groupData, temp, or setSelectedTab variables change.
  // It filters the company group hours based on certain conditions and updates the state variables accordingly.
  useEffect(() => {
    if (
      groupData?.getCompanyGroupsHours &&
      groupData?.getCompanyGroupsHours.length > 0 &&
      temp.length < groupData.getCompanyGroupsHours.length
    ) {
      const newHours = groupData?.getCompanyGroupsHours.filter(
        (item) => !temp.includes(item)
      );
      const oddIndex = groupData?.getCompanyGroupsHours.indexOf(newHours[0]);
      setSelectedTab(oddIndex);
      setTemp(groupData?.getCompanyGroupsHours);
    } else {
      setTemp(groupData?.getCompanyGroupsHours || []);
    }
  }, [groupData, temp, setSelectedTab]);

  // React memoized component for a cancel modal

  const [change, setChange] = useState();

  useEffect(() => {
    if (change) {
      setJobs(
        data?.getCompanyHours
          .filter(
            (obj) =>
              obj.onJob == true &&
              obj.day == format(change, "EEEE") &&
              parseInt(groupData?.getCompanyGroupsHours[selectedTab].id) ==
                parseInt(obj.groupId)
          )
          .map((val) => {
            return { startTime: val.startTime, endTime: val.endTime };
          })
      );
      setTimeout(() => {
        setShowCancelModal5(change);
      }, 100);
    }
  }, [change]);

  const overridePart = () => {
    return (
      <div
        className="displayFlex column hundred"
        style={{
          gap: "15px",
        }}
      >
        <div className="overrideBox">
          <h3 style={{ margin: 0 }}>Add date overrides</h3>
          <Button
            variant="outlined"
            style={{ borderRadius: "20px", width: "100%" }}
            onClick={() => {
              setJobs([
                {
                  startTime: translateFormat("9:00am", HourFormat()),
                  endTime: translateFormat("5:00pm", HourFormat()),
                },
              ]);
              setShowCancelModal4(true);
            }}
          >
            Add a date override
          </Button>
        </div>
        <div
          style={{
            maxHeight: "553px",
            overflow: "auto",
          }}
        >
          {overrideGroupData?.getOverrideGroups
            .filter(
              (val) =>
                val.groupId == groupData?.getCompanyGroupsHours[selectedTab].id
            )
            .sort((a, b) => new Date(a.date) - new Date(b.date))
            .reduce((acc, val, ind, arr) => {
              const currentDate = new Date(val.date);
              const prevDate = ind > 0 ? new Date(arr[ind - 1].date) : null;
              const isDateContinuous =
                prevDate &&
                (currentDate - prevDate) / (1000 * 60 * 60 * 24) === 1;

              const currentOverrides = overrideData?.getOverrides.filter(
                (vall) => vall.groupId == val.id
              );

              const prevOverrides = overrideData?.getOverrides.filter(
                (vall) => vall.groupId == arr[ind - 1]?.id
              );

              const isMatching =
                prevOverrides &&
                currentOverrides.length === prevOverrides.length &&
                currentOverrides.every((val, index) => {
                  const otherVal = prevOverrides[index];
                  return (
                    otherVal &&
                    val.startTime === otherVal.startTime &&
                    val.endTime === otherVal.endTime
                  );
                });

              if (isDateContinuous && isMatching) {
                acc[acc.length - 1].dateRange.push(val.date);
                acc[acc.length - 1].ids.push(val.id);
              } else {
                acc.push({
                  groupId: val.groupId,
                  userId: val.userId,
                  dateRange: [val.date],
                  ids: [val.id],
                  id: val.id,
                });
              }

              return acc;
            }, [])
            .map((val) => ({
              groupId: val.groupId,
              userId: val.userId,
              startDate: val.dateRange[0],
              endDate: val.dateRange[val.dateRange.length - 1],
              dateRange: val.dateRange,
              id: val.id,
              ids: val.ids,
            }))
            .map((val, ind) => (
              <>
                {ind == 0 ? <Divider /> : ""}
                <div
                  className="overrideCard"
                  style={{
                    padding: "20px",
                    display: "flex",
                  }}
                  onClick={() => {
                    setShowCancelModal4(true);
                    setUse(val.dateRange.map((val) => val));
                    setGroupId(val.ids.length > 1 ? val.ids : val.id);
                    setJobs(
                      overrideData?.getOverrides
                        .filter((vall, ind) => val.id == vall.groupId)
                        .map((val) => {
                          return {
                            startTime: val.startTime,
                            endTime: val.endTime,
                            id: val.id,
                          };
                        })
                    );
                  }}
                >
                  <div className="flex">
                    <div
                      className="displayFlex align"
                      style={{
                        flex: 7,
                        fontSize: "0.9em",
                      }}
                    >
                      {isValid(new Date(val.startDate)) &&
                      isValid(new Date(val.endDate)) ? (
                        val.endDate == val.startDate ? (
                          format(new Date(val.startDate), "MMMM dd, yyyy")
                        ) : (
                          <div>
                            <div>
                              {format(new Date(val.startDate), "MMMM dd, yyyy")}
                              -
                            </div>
                            {format(new Date(val.endDate), "MMMM dd, yyyy")}
                          </div>
                        )
                      ) : (
                        <Typography>{val.date}</Typography>
                      )}
                    </div>{" "}
                  </div>
                  <div
                    className="flex column justify"
                    style={{
                      gap: "10px",
                    }}
                  >
                    {overrideData?.getOverrides.filter(
                      (vall, ind) => val.id == vall.groupId
                    ).length == 0 ? (
                      <Typography style={{ opacity: "50%" }}>
                        Unavailable
                      </Typography>
                    ) : (
                      overrideData?.getOverrides
                        .filter((vall, ind) => val.id == vall.groupId)
                        .map((val) => (
                          <div className="displayFlex">
                            <Typography
                              style={{
                                fontSize: "0.9em",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                              }}
                            >
                              {val.startTime + " - " + val.endTime}
                            </Typography>
                            <div
                              style={{
                                flex: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: "5px",
                              }}
                            >
                              {" "}
                            </div>
                          </div>
                        ))
                    )}
                  </div>
                  <div>
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        val.ids.forEach((id) => {
                          deleteOverrideGroup({
                            variables: {
                              id: parseInt(id),
                            },
                          })
                            .then((res) => {
                              overrideGroupRefetch();
                              overrideRefetch();
                              setUpdating(true);
                            })
                            .catch((err) => {
                              overrideRefetch();
                              console.error(err);
                            });
                        });
                      }}
                    >
                      <Delete
                        style={{
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </IconButton>
                  </div>
                </div>
                <Divider />
              </>
            ))}
        </div>
      </div>
    );
  };

  const createNewAvailability = (propss, next, pr) => {
    addCompanyHour({
      variables: propss,
    })
      .then((res) => {
        setUpdating(true);

        refetch({
          userId: props.currentUser.userId,
          hours24: HourFormat(),
        });
        groupRefetch();
      })
      .catch((err) => {
        console.log(err);
        refetch({
          userId: props.currentUser.userId,
          hours24: HourFormat(),
        });
        groupRefetch();
      });
  };
  const [currentInputValues, setCurrentInputValues] = useState({});
  const [modifiedDays, setModifiedDays] = useState({
    Sunday: [],
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
  });

  const handleInputChange = (i, type, result, day) => {
    setCurrentInputValues((prevState) => {
      const dayInputs = prevState[day] || [];
      const inputIndex = dayInputs.findIndex((input) => input.id == i);
      if (inputIndex === -1) {
        // this input has not been modified before
        dayInputs.push({
          id: i,
          [type]: result,
          groupId: parseInt(groupData?.getCompanyGroupsHours[selectedTab]?.id),
        });
      } else {
        // this input has been modified before
        dayInputs[inputIndex][type] = result;
      }
      return { ...prevState, [day]: dayInputs };
    });
  };
  const isTimeRangeOverlap = (range1, range2) => {
    // Parse the times
    const range1Start = parse(range1.startTime, HourFormat(), new Date());
    const range1End = parse(range1.endTime, HourFormat(), new Date());

    const checkOverlap = (start1, end1, start2, end2) =>
      (isAfter(start1, start2) && isBefore(start1, end2)) ||
      (isAfter(start2, start1) && isBefore(start2, end1)) ||
      isEqual(start1, start2) ||
      isEqual(start1, end2) ||
      isEqual(end1, start2) ||
      isEqual(end1, end2);

    if (Array.isArray(range2)) {
      return range2.some((r2) => {
        const range2Start = parse(r2.startTime, HourFormat(), new Date());
        const range2End = parse(r2.endTime, HourFormat(), new Date());
        return checkOverlap(range1Start, range1End, range2Start, range2End);
      });
    } else {
      const range2Start = parse(range2.startTime, HourFormat(), new Date());
      const range2End = parse(range2.endTime, HourFormat(), new Date());
      return checkOverlap(range1Start, range1End, range2Start, range2End);
    }
  };
  const handleSaveClick = (day) => {
    if (!modifiedDays[day]) {
      // No changes were made to this day, so we do nothing.
      return;
    }

    var dayInputs = currentInputValues[day] || [];

    // Get the original hours for this day from the company data with the same groupId
    var originalHours = data?.getCompanyHours.filter(
      (obj) =>
        obj.day === day &&
        parseInt(groupData?.getCompanyGroupsHours[selectedTab]?.id) ==
          parseInt(obj.groupId)
    );

    // Sort the combined list by start time
    var sortedHours = originalHours.sort((a, b) => {
      const aStart = parse(a.start, HourFormat(), new Date());
      const bStart = parse(b.start, HourFormat(), new Date());
      return aStart - bStart;
    });
    const id = dayInputs[0]?.id;
    var final = sortedHours.map((val) => {
      var check = val.id == id;
      if (check) {
        return {
          ...val,
          startTime: dayInputs[0]?.start || val.startTime,
          endTime: dayInputs[0]?.end || val.endTime,
        };
      } else {
        return val;
      }
    });
    for (var i = 0; i < final.length; i++) {
      for (var j = 0; j < final.length; j++) {
        if (j == i) {
          continue;
        }
        if (isTimeRangeOverlap(final[i], final[j])) {
          setErrorUpdating("Overlapping Times");
          return;
        }
      }
    }

    dayInputs.forEach((input) => {
      const { id: hourId, start, end, check } = input;

      const dat = data?.getCompanyHours.find(
        (obj) => parseInt(obj.id) == hourId
      );
      if (
        (end &&
          new Date(parse(end, HourFormat(), new Date())) == "Invalid Date") ||
        (start &&
          new Date(parse(start, HourFormat(), new Date())) == "Invalid Date")
      ) {
        setCurrentInputValues({});
        setErrorUpdating("Invalid Time");
        return;
      }
      const hourInput = {
        day: day,
        onJob: check ?? dat?.onJob,
        startTime: start
          ? format(new Date(parse(start, HourFormat(), new Date())), "hh:mmaa")
          : format(
              new Date(parse(dat?.startTime, HourFormat(), new Date())),
              "hh:mmaa"
            ),
        endTime: end
          ? format(new Date(parse(end, HourFormat(), new Date())), "hh:mmaa")
          : format(
              new Date(parse(dat?.endTime, HourFormat(), new Date())),
              "hh:mmaa"
            ),
        groupId: parseInt(groupData?.getCompanyGroupsHours[selectedTab].id),
      };

      if (
        !differenceInMinutes(
          new Date(parse(hourInput.startTime, "h:mmaa", new Date())),
          new Date(parse(hourInput.endTime, "h:mmaa", new Date()))
        ) ||
        isAfter(
          new Date(parse(hourInput.startTime, "h:mmaa", new Date())),
          new Date(parse(hourInput.endTime, "h:mmaa", new Date()))
        )
      ) {
        console.log("times are not proper");
        setErrorUpdating("Times are not proper");
        return;
      }
      updateCompanyHour({
        variables: { hourId: hourId, hourInput },
      })
        .then((result) => {
          setUpdating(true);
          refetch({
            userId: props.currentUser.userId,
            hours24: HourFormat(),
          });
          groupRefetch();
        })
        .catch((error) => {
          console.log(error);
          refetch({
            userId: props.currentUser.userId,
            hours24: HourFormat(),
          });
          groupRefetch();
        });

      // reset the modified state for this day to null after save
      setModifiedDays((prevState) => {
        const dayInputs = prevState[day].filter((input) => input.id !== hourId);
        return { ...prevState, [day]: dayInputs };
      });
    });
    setCurrentInputValues((prevState) => ({ ...prevState, [day]: [] }));
  };
  const [errorUpdating, setErrorUpdating] = useState(false);
  const handleUpdateMondayHours = (i, type, result) => {
    const hourId = i;
    var dat = data?.getCompanyHours.find((obj) => parseInt(obj.id) == i);
    const hourInput = {
      day: dat?.day,
      onJob: type == "check" ? result : dat?.onJob,
      startTime: format(
        new Date(
          parse(
            type == "start" ? result : dat?.startTime,
            HourFormat(),
            new Date()
          )
        ),
        "hh:mmaa"
      ),
      endTime: format(
        new Date(
          parse(type == "end" ? result : dat?.endTime, HourFormat(), new Date())
        ),
        "hh:mmaa"
      ),
      groupId: parseInt(groupData?.getCompanyGroupsHours[selectedTab].id),
    };
    updateCompanyHour({
      variables: { hourId, hourInput },
    })
      .then((result) => {
        setUpdating(true);
        refetch({
          userId: props.currentUser.userId, // Replace with the user ID you want to filter by
          hours24: HourFormat(),
        });
        groupRefetch();
      })
      .catch((error) => {
        console.log(error);
        refetch({
          userId: props.currentUser.userId,
          hours24: HourFormat(),
        });
        groupRefetch();
      });
  };
  useEffect(() => {
    if (updating && !timeoutActiveRef.current) {
      timeoutActiveRef.current = true;

      timeoutRef.current = setTimeout(() => {
        setUpdating(false);
        timeoutActiveRef.current = false;
      }, 2000);
    }

    return () => {
      clearTimeout(timeoutRef.current);
      timeoutActiveRef.current = false;
    };
  }, [updating]);
  useEffect(() => {
    if (notificationRef.current) {
      notificationRef.current.style.height = "0px";

      if (updating) {
        notificationRef.current.style.transition = "height 0.3s ease";
        notificationRef.current.style.height = "50px";
      } else {
        notificationRef.current.style.height = "0px";
      }
    }
  }, [updating]);
  useEffect(() => {
    if (errorUpdating && !errorTimeoutActiveRef.current) {
      errorTimeoutActiveRef.current = true;

      errorTimeoutRef.current = setTimeout(() => {
        setErrorUpdating(false);
        errorTimeoutActiveRef.current = false;
      }, 2000);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      errorTimeoutActiveRef.current = false;
    };
  }, [errorUpdating]);
  useEffect(() => {
    if (errorRef.current) {
      errorRef.current.style.height = "0px";

      if (errorUpdating) {
        errorRef.current.style.transition = "height 0.3s ease";
        errorRef.current.style.height = "50px";
      } else {
        errorRef.current.style.height = "0px";
      }
    }
  }, [errorUpdating]);
  const [overrideView, setOverrideView] = useState(false);
  const [calendarView, setCalendarView] = useState(false);

  const handleTabChanges = (event, newValue) => {
    setSelectedOverrides(newValue);
  };

  const timerRef = useRef(null);

  useEffect(() => {
    isSmallScreen && setCalendarView(false);
  }, [isSmallScreen]);

  useEffect(() => {
    if (updating) {
      // Show notification for 2 seconds
      timerRef.current = setTimeout(() => {
        setUpdating(false);
      }, 3000);
    } else {
      // Cancel any pending timers
      clearTimeout(timerRef.current);
    }
  }, [updating]);

  useEffect(() => {
    if (use.length) {
      setShowCancelModal4(true);
    }
  }, [use]);

  if (
    loading ||
    groupLoading ||
    overrideLoading ||
    overrideGroupLoading ||
    customLoading
  )
    return "loading";
  if (
    error ||
    groupError ||
    overrideError ||
    overrideGroupError ||
    customError
  ) {
    return <Error />;
  }
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <CancelModal
        selectedDates={selectedDates}
        setSelectedDates={setSelectedDates}
        isOpen={showCancelModal}
        currentUser={props.currentUser}
        setJobs={setJobs}
        Job={Job}
        addCompanyHourGroup={addCompanyHourGroup}
        translateFormat={translateFormat}
        addCompanyHour={addCompanyHour}
        showCancelModal={showCancelModal}
        setShowCancelModal2={setShowCancelModal2}
        setShowCancelModal={setShowCancelModal}
        addCompanyHourGroup={addCompanyHourGroup}
        setShowCancelModal3={setShowCancelModal3}
        setShowCancelModal4={setShowCancelModal4}
        setShowCancelModal5={setShowCancelModal5}
        addOverrideGroup={addOverrideGroup}
        showCancelModal2={showCancelModal2}
        groupId={groupId}
        overrideGroupData={overrideGroupData}
        data={data}
        overrideGroupRefetch={overrideGroupRefetch}
        groupData={groupData}
        jobs={jobs}
        showCancelModal3={showCancelModal3}
        overrideRefetch={overrideRefetch}
        deleteCompanyHour={deleteCompanyHour}
        setUpdating={setUpdating}
        deleteOverrideGroup={deleteOverrideGroup}
        showCancelModal4={showCancelModal4}
        selectedTab={selectedTab}
        refetch={refetch}
        deleteCompanyHourGroup={deleteCompanyHourGroup}
        setUse={setUse}
        groupRefetch={groupRefetch}
        use={use}
        showCancelModal5={showCancelModal5}
      />
      <div
        style={{
          maxWidth: "1000px",
          marginBottom: "30px",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: isSmallScreen && "30px",
        }}
      >
        {/* Schedule Selection */}
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "25px",
            paddingLeft: isSmallScreen && "20px",
            maxWidth: "94%",
          }}
        >
          <div
            style={{ minHeight: "35px", alignItems: "end" }}
            className="flex"
          >
            <h5 className="input-label" style={{ margin: 0 }}>
              Choose a schedule below to edit or create a new one that you can
              apply to your event types
            </h5>
          </div>
          <div style={{ minHeight: "25px" }} className="flex align">
            <h4 style={{ margin: 0, fontWeight: 600 }}>Schedule</h4>
          </div>
          <div style={{ display: "flex", gap: "20px" }}>
            {/* Select Dropdown or Tabs */}
            {isSmallScreen ? (
              <Select
                value={selectedTab}
                onChange={(event) => handleTabChange(event)}
                fullWidth
              >
                {groupData?.getCompanyGroupsHours.map((val, ind) => (
                  <MenuItem value={ind} key={ind}>
                    {val.title}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <Tabs
                value={selectedTab}
                onChange={handleChange}
                style={{ display: "flex", gap: "20px" }}
              >
                {groupData?.getCompanyGroupsHours.map((val) => (
                  <Tab label={val?.title} key={val.id} />
                ))}
              </Tabs>
            )}
            {/* Add Schedule Button */}
            <IconButton
              style={{ width: "50px", height: "50px" }}
              onClick={() => {
                setShowCancelModal(true);
              }}
            >
              <Add />
            </IconButton>
          </div>
        </div>
        {/* Schedule Card */}
        <Card
          style={{
            maxWidth: "1000px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            marginBottom: calendarView && "30px",
          }}
        >
          <div
            className="displayFlex column justify"
            style={{
              minHeight: "110px",
            }}
          >
            {/* Schedule Title */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
                padding: "30px 24px 0",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                <h4 style={{ margin: 0 }}>
                  {groupData?.getCompanyGroupsHours[selectedTab]?.title}
                </h4>
                {groupData?.getCompanyGroupsHours[selectedTab]?.def ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <Star
                      color="warning"
                      style={{
                        fontSize: "18px",
                      }}
                    />
                    <Typography
                      style={{
                        fontSize: "13px",
                        opacity: "70%",
                      }}
                    >
                      default Schedule
                    </Typography>
                  </div>
                ) : null}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flex: 1,
                  gap: "20px",
                }}
              >
                {/* View Toggle Buttons */}
                <div style={{ display: isSmallScreen && "none" }}>
                  <ButtonGroup
                    variant="contained"
                    aria-label="outlined primary button group"
                  >
                    <Button
                      variant={!calendarView ? "contained" : "outlined"}
                      onClick={() => setCalendarView(false)}
                      style={{
                        background: !calendarView && "#d9bca9",
                        border: "1px solid #d9bca9",
                        color: !calendarView ? "white" : "#d9bca9",
                      }}
                    >
                      List View
                    </Button>
                    <Button
                      variant={calendarView ? "contained" : "outlined"}
                      onClick={() => setCalendarView(true)}
                      style={{
                        background: calendarView && "#d9bca9",
                        border: "1px solid #d9bca9",
                        color: calendarView ? "white" : "#d9bca9",
                      }}
                    >
                      Calendar View
                    </Button>
                  </ButtonGroup>
                </div>
                {/* Schedule Settings */}
                <div>
                  <Button
                    ref={anchorRef}
                    onClick={handleClick}
                    endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />}
                  >
                    <Settings />
                  </Button>
                  {/* Settings Popover */}
                  <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    placement="bottom-end"
                  >
                    <ClickAwayListener
                      onClickAway={
                        !showCancelModal2 && !showCancelModal3
                          ? handleClose
                          : null
                      }
                    >
                      <Paper style={{ padding: "10px 0", width: "140px" }}>
                        {!groupData?.getCompanyGroupsHours[selectedTab]
                          ?.def && (
                          <Hover
                            onClick={() => {
                              updateCompanyHourGroup({
                                variables: {
                                  input: {
                                    title:
                                      groupData?.getCompanyGroupsHours[
                                        selectedTab
                                      ]?.title,
                                    def: true,
                                  },
                                  groupId: parseInt(
                                    groupData?.getCompanyGroupsHours[
                                      selectedTab
                                    ]?.id
                                  ),
                                },
                              })
                                .then((result) => {
                                  setOpen(false);
                                  setSelectedTab(0);
                                  groupRefetch();
                                  setUpdating(true);
                                })
                                .catch((error) => {
                                  setOpen(false);
                                  setSelectedTab(0);
                                  groupRefetch();
                                });
                            }}
                          >
                            <Star fontSize="13px" />
                            <Typography variant="contained">
                              Set As Default
                            </Typography>
                          </Hover>
                        )}
                        <Hover
                          onClick={() => {
                            setShowCancelModal2(true);
                          }}
                        >
                          <Edit fontSize="13px" />
                          <Typography variant="contained">
                            Update Name
                          </Typography>
                        </Hover>
                        {groupData?.getCompanyGroupsHours?.filter(
                          (obj) =>
                            obj?.id !==
                            groupData?.getCompanyGroupsHours[selectedTab]?.id
                        )?.length ? (
                          <Hover
                            onClick={() => {
                              setShowCancelModal3(true);
                            }}
                          >
                            <Delete fontSize="13px" />
                            <Typography
                              variant="contained"
                              style={{ background: "#d9bca9" }}
                            >
                              Delete
                            </Typography>
                          </Hover>
                        ) : null}
                      </Paper>
                    </ClickAwayListener>
                  </Popper>
                </div>
              </div>
            </div>
            {/* Active On */}
            <div style={{ padding: "20px 15px" }}>
              <h4
                className="font"
                style={{ fontSize: "13px", opacity: "70%", marginLeft: "10px" }}
              >
                ACTIVE ON
              </h4>
              <EventTypesPopper
                group={groupData?.getCompanyGroupsHours[selectedTab]?.id}
                events={props.data}
                groupData={groupData?.getCompanyGroupsHours}
                preData={customData?.getCompanyGroupsHours}
                user={props.decodedToken}
                tab={selectedTab}
                customRefetch={customRefetch}
                eventRefetch={props.refetch}
                setUpdating={setUpdating}
              />
            </div>
          </div>
          <Divider />
          {calendarView ? (
            <AvailabilityCalendar
              setJobs={setJobs}
              setUpdating={setUpdating}
              modal={setChange}
              setSelectedDates={setUse}
              overrideRefetch={overrideRefetch}
              overrideGroupRefetch={overrideGroupRefetch}
              data={data?.getCompanyHours.filter(
                (val, ind) =>
                  groupData?.getCompanyGroupsHours[selectedTab]?.id ==
                  val.groupId
              )}
              override={overrideData?.getOverrides}
              overrideGroup={overrideGroupData?.getOverrideGroups.filter(
                (val) =>
                  val.groupId ==
                  groupData?.getCompanyGroupsHours[selectedTab]?.id
              )}
            />
          ) : (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div>
                  <div style={{ display: !isSmallScreen && "none" }}>
                    {/* This div is hidden on small screens */}
                    <Tabs
                      value={selectedOverrides}
                      onChange={handleTabChanges}
                      style={{
                        display: "flex",
                        gap: "20px",
                        padding: "15px 0 0 0",
                      }}
                    >
                      {/* Tabs component for switching between "Weekly Hours" and "Date overrides" */}
                      <Tab
                        style={{
                          marginLeft: "20px",
                        }}
                        label="Weekly Hours"
                      />
                      <Tab label="Date overrides" />
                    </Tabs>
                    <Divider />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "5%",
                      padding:
                        selectedOverrides == 1 && isSmallScreen
                          ? "0px"
                          : isSmallScreen
                          ? "0px 30px 0px 30px"
                          : "0px 0px 0px 30px",
                    }}
                  >
                    <div
                      style={{
                        flex: 2,
                        paddingTop: "20px",
                        display:
                          selectedOverrides == 1 && isSmallScreen && "none",
                      }}
                    >
                      <h5 style={{ height: "0px" }}>Set your weekly hours</h5>
                      {[
                        { day: "Sunday" },
                        { day: "Monday" },
                        { day: "Tuesday" },
                        { day: "Wednesday" },
                        { day: "Thursday" },
                        { day: "Friday" },
                        { day: "Saturday" },
                      ].map((val, ind) => (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              padding: "15px 0 ",
                              gap: "20px",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {data?.getCompanyHours?.find(
                              (obj) =>
                                obj?.onJob == true &&
                                obj?.day == val?.day &&
                                parseInt(
                                  groupData?.getCompanyGroupsHours[selectedTab]
                                    ?.id
                                ) == parseInt(obj?.groupId)
                            ) ? (
                              // If a company hour is found for the current day and group, render the following content
                              data?.getCompanyHours
                                .filter(
                                  (obj) =>
                                    obj?.day == val?.day &&
                                    parseInt(
                                      groupData?.getCompanyGroupsHours[
                                        selectedTab
                                      ]?.id
                                    ) == parseInt(obj?.groupId)
                                )
                                .map((val, ind) => {
                                  // Map through the filtered company hours for the current day and group and render each item
                                  return (
                                    <>
                                      <div>
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: !isSmallScreen && "40px",
                                            flexDirection:
                                              isSmallScreen && "column",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "5px",
                                              width: "78px",
                                              minWidth: "78px",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Checkbox
                                              style={{
                                                display: ind
                                                  ? "none"
                                                  : "inherit",
                                              }}
                                              checked={val?.onJob}
                                              onClick={() => {
                                                handleUpdateMondayHours(
                                                  parseInt(val.id),
                                                  "check",
                                                  !val?.onJob
                                                );
                                              }}
                                            />
                                            <h5
                                              style={{
                                                display: ind
                                                  ? "none"
                                                  : "inherit",
                                              }}
                                            >
                                              {val.day
                                                .substring(0, 3)
                                                .toUpperCase()}
                                            </h5>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              width: "100%",
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: "300px",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                              }}
                                            >
                                              {/* Input fields to set the start and end time of the company hour */}
                                              <OutlinedInput
                                                style={{
                                                  maxWidth: "100px",
                                                  borderRadius: "10px",
                                                  textTransform: "lowercase",
                                                }}
                                                value={
                                                  currentInputValues[
                                                    val.day
                                                  ]?.find(
                                                    (input) =>
                                                      input.id == val.id
                                                  )?.start ||
                                                  val.startTime.toLowerCase()
                                                }
                                                onChange={(event) => {
                                                  handleInputChange(
                                                    parseInt(val.id),
                                                    "start",
                                                    event.target.value,
                                                    val.day
                                                  );
                                                }}
                                              />
                                              -
                                              <OutlinedInput
                                                style={{
                                                  maxWidth: "100px",
                                                  borderRadius: "10px",
                                                }}
                                                value={
                                                  currentInputValues[
                                                    val.day
                                                  ]?.find(
                                                    (input) =>
                                                      input.id == val.id
                                                  )?.end ||
                                                  val.endTime.toLowerCase()
                                                }
                                                onChange={(event) => {
                                                  handleInputChange(
                                                    parseInt(val.id),
                                                    "end",
                                                    event.target.value,
                                                    val.day
                                                  );
                                                }}
                                              />
                                              {/* Button to delete the company hour */}
                                              <IconButton
                                                onClick={() =>
                                                  deleteCompanyHour({
                                                    variables: {
                                                      id: parseInt(val.id),
                                                    },
                                                  })
                                                    .then((_res) => {
                                                      if (
                                                        currentInputValues[
                                                          val.day
                                                        ]?.find(
                                                          (vall) =>
                                                            val?.id == vall?.id
                                                        )
                                                      ) {
                                                        currentInputValues[
                                                          val?.day
                                                        ] = currentInputValues[
                                                          val?.day
                                                        ]?.filter(
                                                          (vall) =>
                                                            vall?.id != val?.id
                                                        );
                                                      }
                                                      refetch({
                                                        userId:
                                                          props.currentUser
                                                            .userId,
                                                        hours24: HourFormat(),
                                                      });
                                                      setUpdating(true);
                                                    })
                                                    .catch((err) => {
                                                      refetch({
                                                        userId:
                                                          props.currentUser
                                                            .userId,
                                                        hours24: HourFormat(),
                                                      });
                                                      groupRefetch();
                                                      console.log(err);
                                                    })
                                                }
                                              >
                                                <Delete />
                                              </IconButton>
                                            </div>
                                            <div
                                              style={{
                                                display:
                                                  ind == 0 ? "flex" : "none",
                                                justifyContent: "flex-end",
                                                gap: "10px",
                                                alignItems: "center",
                                                flex: 2,
                                              }}
                                            >
                                              <Button
                                                onClick={() => {
                                                  handleSaveClick(val.day);
                                                }}
                                                variant="contained"
                                                style={{
                                                  display:
                                                    (currentInputValues[val.day]
                                                      ? !currentInputValues[
                                                          val.day
                                                        ]?.length ||
                                                        currentInputValues[
                                                          val.day
                                                        ][0]?.groupId !=
                                                          parseInt(
                                                            groupData
                                                              ?.getCompanyGroupsHours[
                                                              selectedTab
                                                            ]?.id
                                                          )
                                                      : true) && "none",
                                                }}
                                              >
                                                SAVE
                                              </Button>
                                              {/* Button to add a new availability based on the previous end time */}
                                              <IconButton
                                                onClick={() => {
                                                  var companyHours =
                                                    data?.getCompanyHours
                                                      .filter(
                                                        (obj) =>
                                                          obj.day == val.day &&
                                                          parseInt(
                                                            groupData
                                                              ?.getCompanyGroupsHours[
                                                              selectedTab
                                                            ]?.id
                                                          ) ==
                                                            parseInt(
                                                              obj.groupId
                                                            )
                                                      )
                                                      .slice(-1)[0];
                                                  var updatedHours = {
                                                    ...companyHours,
                                                  };

                                                  updatedHours.startTime =
                                                    format(
                                                      new Date(
                                                        addHours(
                                                          parse(
                                                            updatedHours.startTime,
                                                            HourFormat(),
                                                            new Date()
                                                          ),
                                                          1
                                                        )
                                                      ),
                                                      HourFormat()
                                                    );

                                                  updatedHours.endTime = format(
                                                    new Date(
                                                      addHours(
                                                        parse(
                                                          updatedHours.endTime,
                                                          HourFormat(),
                                                          new Date()
                                                        ),
                                                        1
                                                      )
                                                    ),
                                                    HourFormat()
                                                  );
                                                  const allHours =
                                                    data?.getCompanyHours.filter(
                                                      (obj) =>
                                                        obj.day == val.day &&
                                                        parseInt(
                                                          groupData
                                                            ?.getCompanyGroupsHours[
                                                            selectedTab
                                                          ]?.id
                                                        ) ==
                                                          parseInt(obj.groupId)
                                                    );

                                                  for (
                                                    var i = 0;
                                                    i < allHours.length;
                                                    i++
                                                  ) {
                                                    if (
                                                      isTimeRangeOverlap(
                                                        updatedHours,
                                                        allHours[i]
                                                      ) &&
                                                      i !=
                                                        allHours.indexOf(
                                                          companyHours
                                                        )
                                                    ) {
                                                      var good = false;
                                                      for (
                                                        var j = 0;
                                                        j < 24;
                                                        j++
                                                      ) {
                                                        var updatedUpdatedHours =
                                                          { ...updatedHours };

                                                        updatedUpdatedHours.startTime =
                                                          format(
                                                            new Date(
                                                              addHours(
                                                                parse(
                                                                  updatedUpdatedHours.startTime,
                                                                  HourFormat(),
                                                                  new Date()
                                                                ),
                                                                j
                                                              )
                                                            ),
                                                            HourFormat()
                                                          );

                                                        updatedUpdatedHours.endTime =
                                                          format(
                                                            new Date(
                                                              addHours(
                                                                parse(
                                                                  updatedUpdatedHours.endTime,
                                                                  HourFormat(),
                                                                  new Date()
                                                                ),
                                                                j
                                                              )
                                                            ),
                                                            HourFormat()
                                                          );

                                                        if (
                                                          !isTimeRangeOverlap(
                                                            updatedUpdatedHours,
                                                            allHours
                                                          )
                                                        ) {
                                                          updatedUpdatedHours.startTime =
                                                            format(
                                                              new Date(
                                                                addHours(
                                                                  parse(
                                                                    updatedUpdatedHours.startTime,
                                                                    HourFormat(),
                                                                    new Date()
                                                                  ),
                                                                  -1
                                                                )
                                                              ),
                                                              HourFormat()
                                                            );

                                                          updatedUpdatedHours.endTime =
                                                            format(
                                                              new Date(
                                                                addHours(
                                                                  parse(
                                                                    updatedUpdatedHours.endTime,
                                                                    HourFormat(),
                                                                    new Date()
                                                                  ),
                                                                  -1
                                                                )
                                                              ),
                                                              HourFormat()
                                                            );
                                                          good = true;
                                                          companyHours =
                                                            updatedUpdatedHours;
                                                          break;
                                                        }
                                                      }
                                                      if (!good) {
                                                        setErrorUpdating(
                                                          "Overlapping Dates"
                                                        );
                                                        return;
                                                      } else {
                                                        break;
                                                      }
                                                    }
                                                  }
                                                  if (companyHours) {
                                                    const endTime = parse(
                                                      companyHours?.endTime ||
                                                        "5:00pm",
                                                      HourFormat(),
                                                      new Date()
                                                    );
                                                    const newStartTime =
                                                      addHours(endTime, 0);
                                                    let newEndTime = addHours(
                                                      endTime,
                                                      1
                                                    );
                                                    createNewAvailability({
                                                      userId:
                                                        props.currentUser
                                                          .userId,
                                                      onJob: true,
                                                      day: val.day,
                                                      startTime: format(
                                                        newStartTime,
                                                        "hh:mmaa"
                                                      ),
                                                      endTime: format(
                                                        newEndTime,
                                                        "hh:mmaa"
                                                      ),
                                                      groupId: parseInt(
                                                        groupData
                                                          ?.getCompanyGroupsHours[
                                                          selectedTab
                                                        ]?.id
                                                      ),
                                                    });
                                                  } else {
                                                    // No company hours found for this day and group, create a new 9 to 5 schedule
                                                    createNewAvailability({
                                                      userId:
                                                        props.currentUser
                                                          .userId,
                                                      onJob: true,
                                                      day: val.day,
                                                      startTime: "9:00am",
                                                      endTime: "5:00pm",
                                                      groupId: parseInt(
                                                        groupData
                                                          ?.getCompanyGroupsHours[
                                                          selectedTab
                                                        ]?.id
                                                      ),
                                                    });
                                                  }
                                                }}
                                              >
                                                <Add />
                                              </IconButton>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                })
                            ) : (
                              /* Render the default availability if no company hours are found */
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: !isSmallScreen && "40px",
                                    flexDirection: isSmallScreen && "column",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "5px",
                                      width: "78px",
                                      minWidth: "78px",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Checkbox
                                      checked={false}
                                      onClick={() => {
                                        // Check if a company hour already exists for the current day and group
                                        data?.getCompanyHours.find(
                                          (obj) =>
                                            obj.day == val.day &&
                                            parseInt(
                                              groupData?.getCompanyGroupsHours[
                                                selectedTab
                                              ]?.id
                                            ) == parseInt(obj?.groupId)
                                        )
                                          ? handleUpdateMondayHours(
                                              // Update the existing company hour's "onJob" status to true
                                              parseInt(
                                                data?.getCompanyHours.find(
                                                  (obj) =>
                                                    obj.day == val.day &&
                                                    parseInt(
                                                      groupData
                                                        ?.getCompanyGroupsHours[
                                                        selectedTab
                                                      ]?.id
                                                    ) == parseInt(obj.groupId)
                                                )?.id
                                              ),
                                              "check",
                                              true
                                            )
                                          : createNewAvailability({
                                              // Create a new availability with default values (9:00am - 5:00pm) for the selected day and group
                                              userId: props.currentUser?.userId,
                                              onJob: true,
                                              day: val.day,
                                              startTime: "9:00am",
                                              endTime: "5:00pm",
                                              groupId: parseInt(
                                                groupData
                                                  ?.getCompanyGroupsHours[
                                                  selectedTab
                                                ]?.id
                                              ),
                                            });
                                      }}
                                    />
                                    <h5>
                                      {val.day.substring(0, 3).toUpperCase()}
                                    </h5>
                                  </div>{" "}
                                  <div
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      height: isSmallScreen && "50px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "300px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        padding: isSmallScreen && "20px 10px",
                                      }}
                                    >
                                      <Typography>Unavailable</Typography>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                        alignItems: "center",
                                        flex: 2,
                                      }}
                                    >
                                      <IconButton
                                        onClick={() => {
                                          const companyHours =
                                            data?.getCompanyHours.find(
                                              (obj) =>
                                                obj.day == val.day &&
                                                parseInt(
                                                  groupData
                                                    ?.getCompanyGroupsHours[
                                                    selectedTab
                                                  ]?.id
                                                ) == parseInt(obj?.groupId)
                                            );
                                          if (companyHours) {
                                            setErrorUpdating(
                                              "Make date available"
                                            );
                                          } else {
                                            // No company hours found for this day and group, create a new 9 to 5 schedule
                                            createNewAvailability({
                                              userId: props.currentUser.userId,
                                              onJob: true,
                                              day: val.day,
                                              startTime: "9:00am",
                                              endTime: "5:00pm",
                                              groupId: parseInt(
                                                groupData
                                                  ?.getCompanyGroupsHours[
                                                  selectedTab
                                                ]?.id
                                              ),
                                            });
                                          }
                                        }}
                                      >
                                        <Add />
                                      </IconButton>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <Divider />
                        </div>
                      ))}
                    </div>
                    {(!isSmallScreen || selectedOverrides == 1) && (
                      <div style={{ flex: 1.5, display: "flex" }}>
                        {!isSmallScreen && <Divider orientation="vertical" />}
                        {overridePart()}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </Card>
        {/* Render a notification if changes were saved */}
        {updating && (
          <div ref={notificationRef} className="notification">
            Changes Saved!
          </div>
        )}{" "}
        {errorUpdating && (
          <div
            ref={errorRef}
            className="notification"
            style={{ width: "170px", border: "2px solid red" }}
          >
            {errorUpdating}
          </div>
        )}
      </div>
    </div>
  );
}

export default AvailabilityPage;
